module.exports = __webpack_public_path__ + "img/maison3.344fb004.jpg";